export const resolveDays = (page = undefined, perpage = undefined, deleted = undefined) => {
    return ['$stateParams', 'dayService', ($stateParams, dayService) => {
        if (!$stateParams.filtertext) {
            return dayService.findAll(page, perpage, deleted).then(list => list);
        }

        return dayService.search('name', $stateParams.filtertext, page).then(list => list);
    }];
};

export const resolveDay = (param = 'day') => {
    return ['$stateParams', 'dayService', ($stateParams, dayService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? dayService.findById($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/resolvers/day.resolver.js